<div class="main-box" role="region" aria-label="Question">
  <div class="box question-div">
    <div class="question-box" [attr.id]="question?.id">
      <h2 class="title">{{ questionTypes[questNo] }}</h2>
      <div class="description-image-container">
        <div class="description-half">
          <div class="description">
            <p class="description-first-sentence">
              {{ splitDescription(question?.body || '').firstSentence }}
            </p>
            <p class="description-remaining" *ngIf="splitDescription(question?.body || '').remainingText">
              {{ splitDescription(question?.body || '').remainingText }}
            </p>
          </div>
          <!-- <p class="description">
            Based on the job tasks, drag and drop the roles on the right
            in the order from those you would <span class="text-bold">enjoy most</span>
            to those you would <span class="text-bold">enjoy least</span>:
          </p> -->
        </div>
        <div class="image-half">
          <div class="image-container" [class.padding-top]="questNo !== 0 && questNo !== 3">
            <img 
              [src]="currentImage" 
              alt="" 
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="box answer-div">
    <div class="sr-only" aria-live="polite">
      {{ selectedItemLabel }}
    </div>
    <div class="answer-layout">
      <div class="options-div">
        <div
          cdkDropList
          [cdkDropListData]="questionOptions"
          class="answer-list"
          role="listbox"
          tabindex="0"
          aria-label="Drag to reorder options"
          (cdkDropListDropped)="drop($event)"
          (focus)="onListFocus($event)"
          (keydown)="onListKeyDown($event)"
        >
          @for (option of questionOptions; track $index) {
            <div
              class="answer-box"
              cdkDrag
              [attr.id]="option.id"
              [cdkDragData]="option"
              (mouseenter)="onAnswerHover(option.uuid)"
              (mouseleave)="onAnswerLeave()"
              tabindex="-1"
              role="option"
              [class.selected]="selectedItemId === option.uuid"
              (keydown)="onAnswerKeyDown($event, option.uuid)"
              (blur)="onAnswerBlur(option.uuid)"
              #itemElement
            >
              <img
                src="/assets/icons/drag-icon.svg"
                alt="" />
              <img
                [src]="`/assets/images/survey/answers/${option.uuid}.png`"
                alt=""
                class="answer-img"
              />
              {{ option.body }}
              @if (debugModeService.isDebugMode) {
                <span class="debug-riasec-badge">{{ option.riasecCategory }}</span>
              }
            </div>
          }
        </div>
        <div class="option-arrow-div">
          <img
            src="/assets/images/survey/answer-option-arrow.svg"
            alt="option-arrow"
            class="option-arrow" />
          <div class="option-label-div">
            <p class="option-label-top">Most enjoy</p>
            <p class="option-label-bottom">Least enjoy</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
